import { MDBCol } from "mdb-react-ui-kit";
import { FC, useMemo } from "react";
import { InfoModalDoubleContent } from "../../../models/common/common";
import { ModalSize } from "../../../models/common/enums";
import { randomUid } from "../../../utils/randomIds";
import InfoModalContainer from "./InfoModal";
import styles from "../../../styles/detail/DetailBookingSidebar/TravelExperienceSectionDetail.module.scss";
import generalSvg from "../../../utils/svg-icon/general";
import socialAndBrandSvg from "../../../utils/svg-icon/socialAndBrand";

const InfoModalDouble: FC<{
    content: InfoModalDoubleContent;
    show: boolean;
    setShow: (state: boolean) => void;
}> = ({ content, show, setShow }) => {
    const { Star } = generalSvg;
    const { SketchLine } = socialAndBrandSvg;

    const bodyContents = useMemo(() => {
        return content.content.map(el => {
            const isQuality = el.title === "Quality";
            const isPremium = el.title === "Premium";

            return (
                <MDBCol
                    key={randomUid()}
                    size={12}
                    lg={6}
                    className="mt-3 mt-lg-0"
                >
                    <div
                        className={`${styles.package} ${
                            isQuality
                                ? styles.packageQuality
                                : isPremium
                                ? styles.packagePremium
                                : ""
                        }`}
                    >
                        <h1 className={styles.packageTitle}>{el.title}</h1>
                        <p className={styles.packageDescription}>
                            {el.content[0]}
                        </p>
                        {el.listElements.length > 0 && (
                            <>
                                {el.listElements.map(listItem => (
                                    <div
                                        key={randomUid()}
                                        className={styles.packageList}
                                    >
                                        <div
                                            className={
                                                isQuality
                                                    ? styles.packageListIconQuality
                                                    : styles.packageListIconPremium
                                            }
                                        >
                                            {isQuality ? (
                                                <Star />
                                            ) : (
                                                <SketchLine />
                                            )}
                                        </div>
                                        <p className={styles.packageListText}>
                                            {listItem}
                                        </p>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                </MDBCol>
            );
        });
    }, [content]);

    return (
        <InfoModalContainer
            title={content.title}
            show={show}
            setShow={setShow}
            size={ModalSize.LG}
        >
            <div className={styles.container}>
                <div className={styles.containerPackageSection}>
                    {bodyContents}
                </div>
            </div>
        </InfoModalContainer>
    );
};

export default InfoModalDouble;
